import $ from 'jquery';
import Vue from 'vue'
import VueRouter from 'vue-router'
import vSelect from 'vue-select'
import Vuex from 'vuex';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons'
import wait from './components/other/wait'
import DatePicker from 'vue2-datepicker'
import swal from 'sweetalert'
import axios from 'axios';
import moment from 'moment'
import { bus } from './components/other/bus'
import 'vue-range-slider/dist/vue-range-slider.css'


window.Vue = require('vue');
window._ = require('lodash');
global.jQuery = global.$ = $;
window.UIkit = require('uikit');
window.moment = require('moment');

require('air-datepicker/dist/js/datepicker.min.js');

import 'vue-select/dist/vue-select.css';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import 'air-datepicker/dist/css/datepicker.min.css'

import storage from './components/store/store'

// LOCALE
moment.locale('ru');

// FA
import '@fortawesome/fontawesome-free/js/all.min'

// VUE FILTERS
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('D MMMM Y');
  }
});

Vue.filter('cifer', (val) => {
  return val.toLocaleString('ru');
});


// USES
Vue.use(VueRouter)
Vue.use(Vuex);
Vue.use(DatePicker)
UIkit.use(Icons);

axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';


// VUE COMPONENTS
Vue.component('v-select', vSelect)
Vue.component('billing', require('./billing/billing').default);
Vue.component('login', require('./components/mental/login.vue').default);
Vue.component('prepod', require('./components/mental/prepod.vue').default);
Vue.component('student', require('./components/mental/student.vue').default);
Vue.component('back', require('./components/mental/back.vue').default);
Vue.component('account-restore', require('./components/account-restore.vue').default);
Vue.component('account-reset', require('./components/account-reset.vue').default);
Vue.component('headscores', require('./components/other/headscores').default);
Vue.component('headrating', require('./components/other/headrating').default);
Vue.component('headoutsider', require('./components/mental/prepod/outsider/outsider_headline').default);
Vue.component('crm', require('./components/crm/crm').default);

/* Yandex */
let Yacounter = {
  num: '51115889',
  goal: 'ZAYKA'
};

const store = new Vuex.Store(storage);

const app = new Vue({
  store,
  el: '#app',
  mixins: [
    //cf
  ],
  data: {
    loaded: false,
    prod_qnt: 1,
    wait: false,
    url: init.url,
    modal: {
      title: "Заказать звонок",
      button: 'Отправить',
      theme: 'Заявка',
      vopr: false,
    },

    confid: true,
  },
  computed: {},
  methods: {
    getThemeUrl() {
      return this.url + '/themes/genius/assets/';
    },
    setModal(title = 'Заявка', theme = 'Заявка', button = 'Отправить', vopr = false) {
      let modal = {
        title,
        button,
        theme,
        vopr,
      };
      this.modal = modal;
    },
    counter() {
      if (typeof (window['yaCounter' + Yacounter.num]) !== "undefined") {
        console.log('Счетчик сработал');
        window['yaCounter' + Yacounter.num].reachGoal(Yacounter.goal);
      } else {
        console.log('Счетчик неопределен');
      }
    },
    ajaxes() {
      this.$on('before-axios', () => this.wait = true);
      bus.$on('before-axios', () => this.wait = true);

      bus.$on('after-axios', () => this.wait = false);
      this.$on('after-axios', () => this.wait = false);  
    },
    sendForm(event) {
      let fd = {};
      let form = $(event.target);
      form.serializeArray().forEach(function (element) {
        fd[element.name] = element.value;
      });
      this.wait = true;

      let app = this;
      let formdata = {
        form: fd
      };

      const options = {
        method: 'POST',
        headers: {
          'X-OCTOBER-REQUEST-HANDLER': 'onSend',
          'X-Requested-With': 'XMLHttpRequest'
        },
        data: fd,
        url: window.location.href,
      };
      axios(options).then(function (response) {
        console.log(response.data);
        app.counter();
        app.wait = false;
        app.thanks();
      }).catch(function (error) {
        console.log(error);
      });

    },
    thanks() {
      UIkit.modal('#thanksmodal').show();
    },
    getNoun(number, one, two, five) {
      let n = Math.abs(number);
      n %= 100;
      if (n >= 5 && n <= 20) {
        return five;
      }
      n %= 10;
      if (n === 1) {
        return one;
      }
      if (n >= 2 && n <= 4) {
        return two;
      }
      return five;
    },
    inits() {

    },
  },
  components: { DatePicker, wait },
  mounted() {
    this.inits();
    this.ajaxes();

    /*window.onfocus = function (){
      console.log('In focus');
    }*/
  }
});